<template>
  <section class="commercial-commissions-form">
    <embed-frame
      class="commercial-commissions-form-frame"
      endpoint="bank_commission_rules/form"
      placeholder="Carregando..."
      :settings="embedSettings"
      :callbacks="embedCallbacks"
    />
  </section>
</template>

<script>
  import EmbedFrame from '@sdk/views/Embed/Frame.vue';

  export default {
    name: 'CommercialCommissionsForm',
    components: {
      EmbedFrame,
    },
    computed: {
      embedSettings() {
        return {
          bank_commission_rules: {
            form: {
              store: {
                id: this.$route.params.store_id,
              },
              commission_type: this.$route.params.kind,
            },
          },
        };
      },
      embedCallbacks() {
        return {
          'bank_commission_rules:update': this.callback,
        };
      },
    },
    methods: {
      callback() {
        this.$router.push({
          name: 'settings-commercial-commissions-list',
          params: {
            store_id: this.$route.params.store_id,
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .commercial-commissions-form {
    padding: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      padding: 0 var(--product--pwa--horizontal);
    }
  }
</style>
